import { render, staticRenderFns } from "./ServiceEcosystem.vue?vue&type=template&id=c5878080&scoped=true"
import script from "./ServiceEcosystem.vue?vue&type=script&lang=js"
export * from "./ServiceEcosystem.vue?vue&type=script&lang=js"
import style0 from "./ServiceEcosystem.vue?vue&type=style&index=0&id=c5878080&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5878080",
  null
  
)

export default component.exports